module.exports = __webpack_public_path__ + "static/day04-f82bb11d519165f2cd38dec2b4c0aad9.png";